
import { Component, Vue } from "vue-property-decorator";
import Pagination from "@/components/Pagination/index.vue";
import { IStorageLayerDeliveryNoteInfoModel, IStorageModel } from "@/api/types";
import { getInventoryPlans,editPalnPackages } from "@/api/inventory-plan";
import {
  InventoryPlans,
  UnpackedProductInfos,
  CustomsPackingSet,
} from "@/model/inventory-plan";
import {
  updateProductQuantity,
  updateCustomsPackingInfo,
} from "@/api/customs-packing";

import InventoryTable from "./components/InventoryTable.vue";

@Component({
  name: "wareHouseEntryGuideDiagram",
  components: {
    Pagination,
    InventoryTable,
  },
})
export default class extends Vue {
  private textMap = {
    addStorageColumnRemark: "添加备注",
  };
  private inventoryPlanId: string;
  private dialogFormVisible = false;
  private dialogStatus = "addStorageColumnRemark";
  private allStorageLayerList: IStorageModel[] = [];
  private cascadeProps = {
    multiple: true,
    emitPath: false,
    value: "id",
    label: "name",
  };
  private iStorageLayerDeliveryNoteModels: IStorageLayerDeliveryNoteInfoModel[] =
    [];
  private listLoading = true;
  private listParam = {
    selectedStorageLayer: [],
    storageLayerIds: null,
    deliveryNoteCode: "",
  };
  private tempData = Object.assign({});
  private rules = {
    remark: [{ required: true, message: "备注不能为空" }],
  };

  created() {
    this.inventoryPlanId = this.$route.params.inventoryPlanId;
    this.getDetail();
  }
  private inventoryPlans: InventoryPlans = new InventoryPlans();
  // 查看盘库详情
  private async getDetail() {
    this.listLoading = true;
    const data: any = await getInventoryPlans(this.inventoryPlanId);
    data.hqPackingList.map((item) => {
      item.unpackedProductInfos &&
        item.unpackedProductInfos.map((val) => {
          val.isEdit = false;
          val.originTotalPcs = val.totalNumberPcs;
          val.totalPcs = val.totalNumberPcs;
        });
    });
    this.inventoryPlans = data;
    this.listLoading = false;
  }
  private gotoPackageManagementPage(id: string) {
    this.$router.push({
      path: `/inbound-management/delivery-note/${this.inventoryPlanId}/packing-list/${id}/package-management`,
    });
  }
  private async handleEditProductNumber(row: UnpackedProductInfos) {
    await updateProductQuantity(row.id, { quantity: row.totalNumberPcs });
    await this.getDetail();
  }
  private async onDialogConfirmed(row: CustomsPackingSet) {
    const writePackingInfoInput = new WritePackingInfoInput(
      row
    );
    await editPalnPackages(
      writePackingInfoInput.id,
      writePackingInfoInput
    );
    await this.getDetail();
  }
}
class WritePackingInfoInput {
  id: string;
  grossWeight: number;
  netWeight: number;
  length: number;
  width: number;
  height: number;

  constructor(row: CustomsPackingSet) {
    this.id = row.id;
    this.grossWeight = row.packingWeight.grossWeight;
    this.netWeight = row.packingWeight.netWeight;
    this.length = row.packingVolume.length;
    this.width = row.packingVolume.width;
    this.height = row.packingVolume.height;
  }
}
